import React, { createContext, useReducer } from 'react';

import Component from '../../types/Component';
import { BookingType } from '../../types/booking';
import { getBookingStorage } from '../../utils/booking';

import bookingStorageReducer from './reducer';
import { BookingStorageDispatcher } from './types';

export const BookingStorageContext = createContext({
	state: [] as BookingType[],
	dispatch: {} as BookingStorageDispatcher,
});

const bookingStorageInitial = getBookingStorage() ?? [];

const BookingStorageProvider: Component<{}> = ({ children }) => {
	const [state, dispatch] = useReducer(bookingStorageReducer, bookingStorageInitial);

	return (
		<BookingStorageContext.Provider value={{ state, dispatch }}>
			{children}
		</BookingStorageContext.Provider>
	);
};

export default BookingStorageProvider;
